import React, { useState, useRef, useEffect } from 'react';
import iconUpload from '../../images/icon-upload.svg';
import axios from "axios";
import * as securityHelper from "../../helper/SecurityHelper";

export default function Request({ setRequest, setSnackbarTxt }: any) {
  const [fileName, setFileName] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const [evntCdList, setEvntCdList] = useState<any>([]);
  const user = securityHelper.getLoginUser();
  const evntSeqRef = useRef<any>();
  const [evntInfo, setEvntInfo] = useState<any>({});
  const cntntsRef = useRef<any>();
  const btnRef = useRef<any>();
  const [saving, setSaving] = useState(false);
  const [imgSrc, setImgSrc] = useState('');

  const fileHandler = () => { fileRef.current.click(); };

  useEffect(() => {
    fn_retrieveTodayWrkDclrEvntCdList();
  }, []);
  useEffect(() => {
    if (evntCdList.length === 1) {
      evntSeqRef.current.value = evntCdList[0].evntSeq;
      fn_retrieveTodayPtcptEvntInfo(evntCdList[0].evntSeq);
    }
  }, [evntCdList])
  useEffect(() => {
    let imageSrc;
    if (fileRef.current) {
      const afFileList = fileRef.current.files;
      if (afFileList.length > 0) {
        imageSrc = URL.createObjectURL(afFileList[0]);
        setImgSrc(imageSrc);
      }
    }
  }, [fileName])

  const fn_retrieveTodayPtcptEvntInfo = async (evntSeq: bigint) => {
    const evntInfo = await axios.post("admin/api/sgst/retrieveEvntDtlInfo", { evntSeq: evntSeq })
    setEvntInfo(evntInfo.data);
  }

  const fn_retrieveTodayWrkDclrEvntCdList = async () => {
    const rtrnData = await axios.post('admin/api/sgst/retrieveTodayWrkDclrEvntCdList', { userSeq: user.seq, auth: user.auth, hstCmpnySeq: user.companySeq });
    setEvntCdList(rtrnData.data);
  }

  const fn_onEvntSelChg = (e: any) => {
    fn_retrieveTodayPtcptEvntInfo(e.target.value)
  }

  const fn_saveBtn = () => {
    btnRef.current.setAttribute("readonly", "readonly");
    setSaving(true);
  };

  useEffect(() => {
    if (saving) {
      fn_save();
    }
  }, [saving]);

  const fn_save = async () => {
    const evntSeq = evntSeqRef.current.value;
    const cntnts = cntntsRef.current.value;
    const fileList = fileRef.current.files;
    const formData = new FormData();
    let prcsStatCd = '002';
    const rgstrSeq = user.seq;
    const rgstCmpnySeq = user.companySeq;

    if (!evntSeq) {
      setSnackbarTxt('행사를 선택해 주세요.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      evntSeqRef.current.style.border = 'solid 1.5px rgba(224, 81, 133, 0.5)';
      setTimeout(() => evntSeqRef.current.style.border = 'solid 1px #D9D9D9', 2000);
      return;
    }

    if (!cntnts) {
      setSnackbarTxt('내용을 입력해 주세요.');
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      cntntsRef.current.focus();
      return;
    }

    if (fileList.length > 0) {
      formData.append('multipartFiles', fileList[0]);
    }

    const jsonObject = {
      evntSeq: evntSeq,
      prcsStatCd: prcsStatCd,
      cntnts: cntnts,
      rgstrSeq: rgstrSeq,
      rgstCmpnySeq: rgstCmpnySeq,
      rqstrAuthSeq: user.authSeq
    };

    formData.append('jsonData', JSON.stringify(jsonObject));

    const rtrnData = await axios.post('admin/api/wrkStopRqst/registWrkStopRqstData', formData);

    if (rtrnData.data > 0) {
      setSnackbarTxt('처리 되었습니다.');
      setTimeout(() => setRequest(false), 1000);
    }
  }

  const dataHeaderStyle = 'ml-7 text-14 leading-17 font-preBold md:ml-[17px] md:text-35 md:leading-[42px]';

  return (
    <div className='h-[calc(100%-52px)] md:h-[calc(100%-130px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center'>
      <div className='w-[265px] sm:w-[318px] md:w-[750px] mb-20 md:mb-[50px]'>
        <p className='mt-33 ml-7 font-preBold text-15 leading-18 md:mt-[82px] md:ml-[17px] md:text-37 md:leading-[45px]'>신고 내용</p>
        <div className='w-full border border-x-0 border-t-0 border-[#CACACA] mt-15 mb-22 md:mt-[37px] md:mb-[55px]' />
        <div className='md:relative flex items-center justify-between md:after:w-[20px] md:after:h-[20px] md:after:border-black md:after:border-b-2 md:after:border-r-2 md:after:transform md:after:rotate-45 md:after:absolute md:after:left-[700px] md:after:mb-[10px]'>
          <p className={dataHeaderStyle}>행사명</p>
          {user.auth !== 'WOK' ?
            <select ref={evntSeqRef} onChange={fn_onEvntSelChg} className='w-[235px] font-preLight text-12 sm:text-14 leading-17 md:w-[587px] md:text-35 md:leading-[42px]  border border-[#D9D9D9] outline-none bg-white text-txtBlack h-32 md:h-[80px] flex justify-between items-center rounded-[5px] md:rounded-[12px] md:appearance-none md:pl-[37px]'>
              <option value=''>선택</option>
              {evntCdList.map((evntCdData: any) => (
                <option key={evntCdData.evntSeq} value={evntCdData.evntSeq}>{evntCdData.evntNm}</option>
              ))}
            </select>
          : evntCdList.map((evntCdData: any) => (
                  <><input type='hidden' value={evntCdData.evntSeq} ref={evntSeqRef} />
                  <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{evntCdData.evntNm}</p></>

            ))}
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>장소</p>
        <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{evntInfo.exbtPlc}</p>
        </div>
        <div className='flex items-center justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>신고자</p>
          <p className='w-[182px] sm:w-[235px] md:w-[587px] font-preLight text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'>{user.name}</p>
        </div>
        <div className='flex justify-between mt-16 md:mt-[40px]'>
          <p className={dataHeaderStyle}>내용</p>
          <textarea ref={cntntsRef} className='w-[182px] sm:w-[235px] md:w-[587px] h-130 md:h-[325px] px-10 pt-10 md:px-[25px] md:pt-[25px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px] outline-none bg-[#F6F6F8] rounded-[5px] md:rounded-[12px] placeholder:text-12 sm:placeholder:text-14 md:placeholder:text-35 placeholder:text-[#9C9C9B] placeholder:leading-16 md:placeholder:leading-[40px] placeholder:font-preLight ' placeholder='내용을 입력해주세요.' />
        </div>
        <div className='flex justify-between mt-24 md:mt-[60px]'>
          <p className={dataHeaderStyle}>사진첨부</p>
          <div className='w-[182px] sm:w-[235px] md:w-[587px]'>
            {!fileName
              ? <button onClick={fileHandler} className='flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                <p>파일 올리기</p>
              </button>
              : <><img onClick={fileHandler} src={imgSrc} alt='doneImage' className='object-cover border border-[#D9D9D9] md:w-[65px] md:h-[65px]' />
                  <button onClick={fileHandler} className='my-7 md:my-[17px] flex justify-center items-center w-[70%] h-38 md:h-[95px] outline-none border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-gray-400 font-preLight'>
                    <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                    <p>삭제</p>
                  </button></>}
            <input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />
          </div>
        </div>
      </div>
      <button ref={btnRef} onClick={fn_saveBtn} className='font-preLight text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto mb-20 pt-10 pb-10 md:mb-[50px] md:pt-[25px] md:pb-[25px]'>{'작업중지요청'}</button>
    </div>
  );
}

